import * as Yup from "yup";

export const offerValidationSchema = Yup.object().shape({
  applicationId: Yup.string().required('Application is required'),
  candidateName: Yup.string().required('Candidate name is required'),
  subject: Yup.string()
    .transform((value) => (value ? value.trim() : ''))
    .required('Subject is required')
    .min(3, 'Subject must be at least 3 characters')
    .max(100, 'Subject cannot exceed 100 characters'),
  grossSalary: Yup.number()
    .typeError('Gross salary must be a valid number')
    .required('Gross salary is required')
    .min(0, 'Gross salary cannot be negative'),
  ctcSalary: Yup.number()
    .typeError('CTC salary must be a valid number')
    .required('CTC salary is required')
    .min(0, 'CTC salary cannot be negative'),
  currency: Yup.string()
    .required('Currency is required'),
  frequency: Yup.string()
    .required('Frequency is required'),
  pf: Yup.boolean(),
  // Optional: for salary breakdown section
  salaryStructure: Yup.array()
    .of(
      Yup.object().shape({
        componentName: Yup.string().required('Component name is required'),
        percentage: Yup.number()
        .min(0, 'Percentage cannot be negative')
        .max(100, 'Percentage cannot exceed 100')
          .required('Percentage is required'),
      amount: Yup.number()
        .typeError('Amount must be a valid number')
        .min(0, 'Amount cannot be negative')
          .required(),
      })
    )
    .min(1, 'At least one salary component is required')
    .test(
      'total-percentage-100',
      'Total percentage must equal 100%',
      function (components) {
        if (!components) return false;

        const total = components.reduce(
          (sum, item) => sum + (Number(item.percentage) || 0),
          0
        );

        return total === 100;
      }
    ),
  templateId: Yup.string(),
  joiningDate: Yup.date()
    .required('Joining date is required')
    .test(
      'joining-before-expiry',
      'Joining date must be after expiry date',
      function (value) {
        const { offerExpiryDate } = this.parent;

        // ⛔ If expiry date is missing → skip validation → return true
        if (!offerExpiryDate) return true;

        // ⛔ If joining date is missing → fail (because required)
        if (!value) return false;

        // ✅ Validate only when both dates exist
        return new Date(value) > new Date(offerExpiryDate);
      }
    ),
  offerExpiryDate: Yup.date()
    .required('Expiry date is required')
    .test(
      'expiry-after-joining',
      'Expiry date must be before joining date',
      function (value) {
        const { joiningDate } = this.parent;

        // ⛔ If expiry date is missing → skip validation → return true
        if (!joiningDate) return true;

        // ⛔ If joining date is missing → fail (because required)
        if (!value) return false;

        // ✅ Validate only when both dates exist
        return new Date(value) < new Date(joiningDate);
      }
    ),
  offerLetterContent: Yup.string()
    .test(
      "not-empty-trimmed",
      "Offer letter content is required",
      (value) => {
        if (!value) return false;

        const clean = value
          .replace(/<[^>]*>/g, "")   // remove tags
          .replace(/&nbsp;/g, " ")
          .trim();

        return clean.length > 0;
      }
    )
    .required("Offer letter content is required"),

});
